import { createAction } from 'redux-actions';
import { DOCUMENTS_REQUEST, DOCUMENTS_SUCCESS, DOCUMENTS_FAILURE } from './constants';

export const fetchDocuments = createAction(DOCUMENTS_REQUEST);
export const documentsSuccess = createAction(DOCUMENTS_SUCCESS);
export const documentsFailure = createAction(DOCUMENTS_FAILURE);
